module.exports = __webpack_public_path__ + "static/media/HeroGrowTower.962410f0.jpg";